export default __webpack_public_path__ + "static/media/8f315192715d883d043bdcb0749593b1.png";